// Photo mosaic: a plain header row (title, description, "see all") over a bento
// grid of image cards. The first destination is featured at double size on
// tablet and up; on phones the cards scroll horizontally.
export const DESTINATIONS_SHOWCASE_STYLES = {
  root: "w-full min-w-0",
  header: "flex flex-col gap-3 md:flex-row md:items-end md:justify-between md:gap-6",
  headerCopy: "min-w-0 max-w-2xl",
  title: "text-[20px] md:text-[24px] font-bold text-ticketon-dark-text",
  description: "mt-2 text-[13px] md:text-[14px] text-ticketon-gray-600 [&>span]:font-bold",
  exploreLink:
    "inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-ticketon-light-gray bg-white px-4 py-2 text-[13px] font-semibold text-ticketon-dark-blue transition-colors duration-200 hover:border-ticketon-dark-blue hover:bg-ticketon-dark-blue hover:text-white md:self-auto",
  exploreIcon: "h-4 w-4 transition-transform duration-200 group-hover/explore:translate-x-0.5",
  grid:
    "mt-4 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-2 scrollbar-hide md:grid md:grid-flow-dense md:grid-cols-3 md:gap-4 md:overflow-visible md:pb-0 lg:grid-cols-4",
  card:
    "group relative block aspect-[4/5] w-[228px] shrink-0 snap-start overflow-hidden rounded-[20px] bg-ticketon-dark-blue shadow-ticketon-card md:aspect-square md:w-auto",
  cardFeatured: "md:col-span-2 md:row-span-2 md:aspect-auto",
  cardLinked: "cursor-pointer",
  cardImage:
    "absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105",
  cardOverlay:
    "absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent",
  cardContent: "absolute inset-x-0 bottom-0 flex flex-col gap-0.5 p-4 text-white md:p-5",
  cardLocation: "text-[11px] font-semibold uppercase tracking-wider text-white/80",
  cardName: "text-[18px] font-bold leading-tight drop-shadow-sm",
  cardNameFeatured: "md:text-[28px]",
} as const;
